/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import Config from "data/config";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { objectHasPropertyString } from "utils/empty-exists";

const CroppedFocusImage = (props) => {
    const { image, settings } = props || {};
    const { options } = settings || {};
    const {
        // method,
        position = "center center",
        useCaption,
        dimension = 340
    } = options || {};
    
    // const { width = 320, height = 240 } = image || {}
    // const longerSide = width <= height ? 'height' : 'width'
    // let aspect_ratio = (longerSide === 'width') ? height/width : width/height
    // let dimension = (longerSide === 'width') ? width : height
    let displayWidth = "100%";
    let displayHeight = `${dimension}px`;
    // const otherDimension = dimension * aspect_ratio
    const image_style = image
        ? {
            width: displayWidth,
            height: displayHeight,
            backgroundPosition: `${position}`,
            backgroundImage: `url('${image.url}')`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            // aspectRatio: '16/9'
        }
        : {};
    
    // let class_list = ['simplicity-cover-image-thumb', 'cover']
    const message = "No image to display";
    const component = { type: "component.image" };
    const enableImageDebug = Config.Debug.useDebug;
    
    return (
        <>
            {image &&
                <>
                    {enableImageDebug &&
                        <h6>Cropped Focus Image (width: {displayWidth})</h6>
                    }
                    {objectHasPropertyString(image,"url") &&
                        <div className='simplicity-cover-image-thumb cover' style={image_style} />
                    }
                    {useCaption && image.caption &&
                        <>
                            <>{image.caption}</>
                        </>
                    }
                </>
            }
            {!image &&
                <>
                    <EmptyContentMessage
                        hasContent={!image}
                        message={message}
                        component={component}
                    />
                </>
            }
        </>
    );
};

export default CroppedFocusImage;
